import { render } from "./GenerateFormItem.vue?vue&type=template&id=677879d4&scoped=true"
import script from "./GenerateFormItem.vue?vue&type=script&lang=js"
export * from "./GenerateFormItem.vue?vue&type=script&lang=js"

import "./GenerateFormItem.vue?vue&type=style&index=0&id=677879d4&lang=less&scoped=true"

import exportComponent from "E:\\self\\loyi\\pro-DT-member-cms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-677879d4"]])

export default __exports__